// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/tag/style/index.css
// module id = 837
// module chunks = 0